import { render, staticRenderFns } from "./ManageCardResidence.vue?vue&type=template&id=166e7a5d&scoped=true"
import script from "./ManageCardResidence.vue?vue&type=script&lang=js"
export * from "./ManageCardResidence.vue?vue&type=script&lang=js"
import style0 from "./ManageCardResidence.vue?vue&type=style&index=0&id=166e7a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e7a5d",
  null
  
)

export default component.exports